import { styled } from '@ori-ui/mui';

export const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(3),
  padding: theme.spacing(6, 3),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(6),
  },
}));

export const IconContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 80,
  justifySelf: 'stretch',
  color: theme.palette.error.dark,
}));

export const ButtonContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(3),
  width: '100%',
}));
